import { decodeFromBase64 } from "./base64";

export const getFilenameName = (filename: string) => {
  return decodeFromBase64(filename).split("\\").at(-1) as string;
};
